<template>
  <div class="search-box">
    <Dropdown
      :trigger="['click']"
      overlayClassName="search-dropdown"
      placement="bottomCenter"
      :getPopupContainer="
        (triggerNode) => {
          return triggerNode.parentNode || document.body;
        }
      "
    >
      <div class="search-input-wrap">
        <input
          class="search-input"
          type="text"
          :allowClear="true"
          @keyup.enter="onSearch"
          v-model="keyValue"
          placeholder="述职"
        />
        <i class="svg-icon" @click="onSearch"
          ><svg-icon name="search" width="16px" height="16px"></svg-icon
        ></i>
      </div>
      <template #overlay>
        <Menu>
          <div class="search-content">
            <div class="search-item history" v-if="historyList.length > 0">
              <h2>搜索历史</h2>
              <ul>
                <li v-for="(name, ind) in historyList" :key="ind" @click="onKey(name)">
                  <a>{{ name }}</a>
                </li>
              </ul>
            </div>
            <div class="search-item hot">
              <h2>大家都在搜</h2>
              <ul>
                <li
                  v-for="(item, ind) in searchList"
                  :key="ind"
                  @click="onKey(item.name)"
                >
                  <i>{{ ind + 1 }}</i
                  ><a>{{ item.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </Menu>
      </template>
    </Dropdown>
  </div>
</template>

<script lang="ts">
import { CommonService } from "@/api/common";
import router from "@/router";
import { MutationTypes, useStore } from "@/store";
import { computed, defineComponent, reactive, toRefs, ref } from "vue";

export default defineComponent({
  name: "SearchBanner",
  components: {},
  setup() {
    const store = useStore();
    const search = computed(() => store.state.seachKey);
    const searchKey = reactive({
      keyValue: search.value,
    });

    const historyList = computed(() => store.state.searchHistoryList);
    const onSearch = () => {
      router.push("/templates/FL0");
      store.commit(MutationTypes.SET_SEARCH_KEY, searchKey.keyValue);
    };
    const onKey = (name: string) => {
      searchKey.keyValue = name;
      onSearch();
    };
    const searchList = ref([]);
    const getSearchTags = async () => {
      const params = {};
      const res = await CommonService.getSearchTags(params);
      if (res.data.state === 2) {
        searchList.value = res.data.data;
      }
    };
    getSearchTags();
    return {
      ...toRefs(searchKey),
      onSearch,
      historyList,
      searchList,
      onKey,
    };
  },
});
</script>

<style lang="scss">
.search-box {
  position: relative;
  z-index: 9;
  width: 100%;
  .search-input-wrap {
    background: #f6f7f9;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .search-input {
      height: 42px;
      padding: 0 12px;
      width: 100%;
    }
    .svg-icon {
      cursor: pointer;
      margin: 0 5px;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgb(141, 146, 152);
    }
    .svg-icon:hover {
      color: $themeColor;
    }
  }
  .search-input-wrap.ant-dropdown-open {
    background-color: #f0f3f9;
  }
}
</style>
